import type { GetUserTaskResponse, ToDoTaskRow } from "@/openapi/generated";

/** Studio-created tasks have no workflow `sourceModule`; system-generated tasks do. */
export function isManualUserTask(
  task: Pick<GetUserTaskResponse, "sourceModule"> | Pick<ToDoTaskRow, "sourceModule">,
): boolean {
  return !task.sourceModule?.trim();
}

export function filterManualUserTasks<T extends Pick<GetUserTaskResponse, "sourceModule">>(
  tasks: readonly T[],
): T[] {
  return tasks.filter(isManualUserTask);
}
